import { render, staticRenderFns } from "./Completed.vue?vue&type=template&id=27ceb7e4&scoped=true&"
import script from "./Completed.vue?vue&type=script&lang=ts&"
export * from "./Completed.vue?vue&type=script&lang=ts&"
import style0 from "./Completed.vue?vue&type=style&index=0&id=27ceb7e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ceb7e4",
  null
  
)

export default component.exports